import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import React, { useRef } from 'react';

import { LogsTable } from 'components/LogsTable';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function Logs() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout title="Logs">
        <LogsTable id="logs-table" ref={tableRef} />
      </TablePageLayout>
    </HideStationSelector>
  );
}
